import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus } from '../../../utils/china-area-data'

export let provinceArray = []

export let provinceLabelToValue = {}

export let provinceValueToLabel = {}

export let cityMapFromProvinceCode = {}

export let cityMapFromProvinceLabel = {}

export let districtMapFromCityCode = {}

export let districtMapFromCityLabel = {}

regionData.forEach(province => {
  province.name = province.label
  province.all = {label: province.label, value: province.value}
  provinceArray.push({
    label: province.label,
    value: province.value
  })

  provinceLabelToValue[province.label] = province.value

  provinceValueToLabel[province.value] = province.label

  if (province.children) {
    cityMapFromProvinceCode[province.value] = []

    cityMapFromProvinceLabel[province.label] = []

    province.children.forEach(city => {
      city.label = city.label === '市辖区' ? province.label : city.label
      city.name = city.label
      city.all = {label: city.label, value: city.value}
      const cityLabel = city.label
      const cityValue = city.label

      const cityData = {
        label: cityLabel,
        value: cityValue
      }

      cityMapFromProvinceCode[province.value].push(cityData)

      cityMapFromProvinceLabel[province.label].push(cityData)

      if(city.children) {

        districtMapFromCityCode[cityValue] = []

        districtMapFromCityLabel[cityLabel] = []

        city.children.forEach(district => {
          district.name = district.label
          district.all = {label: district.label, value: district.value}
          const districtData = {
            label: district.label,
            value: district.value
          }

          districtMapFromCityCode[cityValue].push(districtData)

          districtMapFromCityLabel[cityLabel].push(districtData)
        })

      }

    })

  }
})

function setName (province) {
  province.name = province.label
  province.all = {label: province.label, value: province.value}

  if(province.children) {
    province.children.forEach(city => {
      city.label = city.label === '市辖区' ? province.label : city.label
      city.name = city.label
      city.all = {label: city.label, value: city.value}
      if(city.children) {
        city.children.forEach(district => {
          district.name = district.label
          district.all = {label: district.label, value: district.value}
        })
      }
    })
  }
}

provinceAndCityData.forEach(setName)
provinceAndCityDataPlus.forEach(setName)
regionDataPlus.forEach(setName)
